import React from "react";
import { FormContext } from "./contextProvider";

function useFormContext() {
  const context = React.useContext(FormContext);

  return context;
}

export default useFormContext;
